import { fetchDramaInfo, fetchDramaCategories } from '../actions/drama';
import { fetchDramaSeoInfo } from '../actions/seo';

async function fetchData({ dispatch, params }) {
  const { dramaId, id } = params;
  await Promise.all([
    dispatch(fetchDramaInfo(dramaId || id)),
    dispatch(fetchDramaSeoInfo(dramaId || id)),
    dispatch(fetchDramaCategories()),
  ]);
}

export default fetchData;
